import React, { useState, useEffect } from "react";
import { CiLocationOn } from "react-icons/ci";
import { CiBookmark } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CareerCardSkeleton from "./CareerCardSkeleton";
import CareerModal from "./CareerModal";

const CareerCard = () => {
  const navigate = useNavigate();
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showModal, setShowModal] = useState(false);
 const [selectedCareer, setSelectedCareer] = useState(null);

  const handleApplyClick = (career) => {
    setSelectedCareer(career);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/career/all-career`
        );
        console.log("response data----------------->", response.data.data);
        if (response.data.success) {
          // console.log("respons data",response?.data)
          setCareers(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Failed to fetch careers");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCareers();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  if (loading) return <CareerCardSkeleton />;
  if (error)
    return <div className="text-center py-16 text-red-500">{error}</div>;

  return (
    <div>
      <section className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 px-6 md:px-10 py-16 gap-5">
        {careers.map((career) => (
          <div
            data-aos="zoom-in-up"
            data-aos-duration="700"
            key={career._id}
            // onClick={() => handleNavigation(`/career-detail/${career._id}`)}
            className="bg-gradient-to-r hover:scale-105 transition-all duration-300 from-[#0bb7d931] via-white to-[#0bb7d931] rounded-md shadow-lg p-5"
          >
            <div className="flex justify-between items-start">
              <article>
                <h6
                  data-aos="fade-up"
                  data-aos-duration="700"
                  className="sm:text-xl text-lg font-semibold capitalize familjen-font"
                >
                  {career.position}
                </h6>
                <div className="text-xs text-[#4f4f4f] font-semibold flex flex-wrap items-center xl:gap-5 gap-2 my-2">
                  {/* <span data-aos="fade-up" data-aos-duration="700" className="text-green-600 bg-green-400/10 uppercase p-1.5 rounded-md">
                    {career.jobType}
                  </span>
                  <span data-aos="fade-up" data-aos-duration="700">Salary: {career.jobDetail.salary} {career.jobDetail.salaryCurrency}</span> */}
                  <span
                    data-aos="fade-up"
                    data-aos-duration="700"
                    className="text-blue-600 bg-blue-400/10 uppercase p-1.5 rounded-md"
                  >
                    Openings: {career.jobOpenings}
                  </span>
                </div>
              </article>
            </div>
            <div className="flex items-end md:justify-between gap-2 md:flex-row flex-col justify-center">
              <div className="flex gap-2 items-end">
                <figure
                  data-aos={"zoom-in"}
                  data-aos-duration="700"
                  className="h-12 w-12 rounded-md overflow-hidden"
                >
                  <img
                    className="h-full w-full object-cover object-center"
                    src={career.companyLogo}
                    // src={"https://tse3.mm.bing.net/th/id/OIP.uBYsSL7JDekYP3VpxWZvYQHaHa?cb=12&pid=ImgDet&w=151&h=151&c=7&o=7&rm=3"}
                    alt="logo"
                  />
                </figure>
                <div>
                  <h3
                    data-aos="fade-up"
                    data-aos-duration="700"
                    className="font-medium capitalize sm:text-lg"
                  >
                    {/* {career.company.companyName} */}
                    Diagnonext
                  </h3>
                  <p
                    data-aos="fade-up"
                    data-aos-duration="700"
                    className="flex items-center gap-1 text-[#4f4f4f] sm:text-sm text-xs"
                  >
                    <span>
                      <CiLocationOn />
                    </span>
                    {/* {career.company.jobLocation} */}
                    Bhubaneswar, Odisha, India
                  </p>
                </div>
              </div>
              <button
                className="mt-2 px-3 py-1 text-sm font-medium text-white bg-[#0bb6d9] rounded hover:bg-[#179bb6] transition"
                onClick={() => handleApplyClick(career)}
              >
                Apply Now
              </button>
            </div>
          </div>
        ))}
      </section>

      {showModal && selectedCareer && <CareerModal setShowModal={setShowModal} selectedCareer={selectedCareer}/>}
    </div>
  );
};

export default CareerCard;
